import { useState, useEffect, useRef } from "react";
import { LOCATIONS, flagOf } from "./countries";
import styles from "./form.module.css";

export default function LocationSelect({ value, onSelect, onOpen, error }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const ref = useRef(null);
  const selected = LOCATIONS.find((c) => c.name === value) || null;

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setQ("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const list = LOCATIONS.filter(
    (c) => !q || c.name.toLowerCase().includes(q.toLowerCase()),
  );

  return (
    <div ref={ref} className={styles.selectWrapFull}>
      <button
        type="button"
        onClick={() => {
          const next = !open;
          setOpen(next);
          if (next && onOpen) onOpen();
        }}
        className={`${styles.selectTriggerFull} ${error ? styles.err : ""}`}
      >
        <span className={styles.selectFlag}>
          {selected ? flagOf(selected.iso) : "📍"}
        </span>
        <span
          className={`${styles.selectFlex} ${!selected ? styles.selectPlaceholder : ""}`}
        >
          {selected ? selected.name : "Select your country"}
        </span>
        <span className={styles.selectChevron}>▼</span>
      </button>

      {open && (
        <div className={styles.dropdownFull}>
          <div className={styles.dropdownSearch}>
            <input
              autoFocus
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search country"
              className={styles.dropdownSearchInput}
            />
          </div>
          <div className={styles.dropdownList}>
            {list.length === 0 && (
              <div className={styles.dropdownEmpty}>No matches</div>
            )}
            {list.map((c) => (
              <div
                key={c.iso}
                onClick={() => {
                  onSelect(c);
                  setOpen(false);
                  setQ("");
                }}
                className={`${styles.dropdownItem} ${selected && c.iso === selected.iso ? styles.selected : ""}`}
              >
                <span className={styles.selectFlag}>{flagOf(c.iso)}</span>
                <span className={styles.dropdownItemName}>{c.name}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
